import React from "react";
import { Button } from "../ui/button";
import { LogOut } from "lucide-react";

export function HeaderActions({ actions = {} }) {
  const {
    showCheckRates = true,
    showApplyLoan = true,
    showLogout = false,
    onCheckRatesClick = null,
    onApplyLoanClick = null,
    onLogoutClick = null,
    disableApplyLoan = false,
  } = actions;
  return (
    <div className="flex items-center gap-3">
      {showCheckRates && (
        <Button
          variant="outline"
          size="default"
          className="border-secondary-2 text-secondary-2 bg-transparent hover:shadow-md"
          onClick={onCheckRatesClick}
        >
          Check Rates
        </Button>
      )}
      {showApplyLoan && (
        <Button
          variant="default"
          size="default"
          className="bg-secondary-2 text-white hover:shadow-md"
          onClick={onApplyLoanClick}
          disabled={disableApplyLoan}
        >
          Apply for Loan
        </Button>
      )}
      {showLogout && (
        <Button
          variant="noCss"
          onClick={onLogoutClick}
          className="flex gap-2"
        >
          <LogOut className="w-4 h-4 text-primary-3" />
          <span>Log Out</span>
        </Button>
      )}
    </div>
  );
}
